var exports = {
  "i": "x93eb46d8--a2f3d1--wrapper",
  "Z": "x93eb46d8--a2f3d1--field",
};

module.exports = exports;
